import { State, Action } from "./types";

const CODE_LENGTH = 4;

export const initialState: State = {
    step: "email",
    email: "",
    code: "",
    loading: false,
    error: null,
};

export const reducer = (state: State, action: Action): State => {
    switch(action.type) {
        case "SET_EMAIL":
            return { ...state, email: action.email, error: null };

        case "SET_CODE":
            return { ...state, code: action.code.replace(/\D/g, "").slice(0, CODE_LENGTH), error: null };

        case "SUBMIT":
            return { ...state, loading: true, error: null };

        case "EMAIL_SUCCESS":
            return { ...state, loading: false, step: "code", code: "", error: null };

        case "CODE_SUCCESS":
            return { ...state, loading: false, step: "done", error: null };

        case "FAIL":
            return { ...state, loading: false, error: action.error };

        case "BACK_TO_EMAIL":
            return { ...state, step: "email", code: "", error: null };


        case "SHOW_QR":
            return { ...state, step: "qr", error: null };

        case "QR_CONFIRMED":
            return { ...state, step: "done", error: null };

        case "SHOW_PASSKEY":
            return { ...state, step: "passkey", loading: false, error: null };

        case "PASSKEY_LINKED":
            return { ...state, loading: false, step: "done", error: null };

        default:
            return state;
    }
};
